import React, { lazy, Suspense, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ReactComponent as Hambuger } from 'assets/images/icon/hamburger.svg';
import newLogo from 'assets/images/logo/unilapse_new_logo.svg';
import group14 from 'assets/images/group-14@2x.png';
import group16 from 'assets/images/group-16@2x.png';
import ellipse14 from 'assets/images/Ellipse 14.png';

import { requestUrl } from 'config';
import { useReactQuery } from 'hooks/useReactQuery';

const MobileNav = lazy(() => import('./MobileNav'));
const SearchNav = lazy(() => import('components/Nav/SearchNav/SearchNav'));
const UserStatus = lazy(() => import('components/Nav/UserStatus'));

const Nav = () => {
  const { getGlobalState } = requestUrl;
  const { data } = useReactQuery('globalState', getGlobalState, { staleTime: 999999, cachTime: 999999 });
  const externalGallery = data && data?.global_url_vr;
  const global_url_top_ad = data && data?.global_url_ads[0].image;
  // const externalStore = 'https://smartstore.naver.com/unilapsegallery';
  const [isClicked, setIsClicked] = useState(false);
  const [showBanner, setShowBanner] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  const [showLaunchAppPopup, setShowLaunchAppPopup] = useState(false);

  const PC_NAV_PAGES = [
    { url: '/about', name: 'About' },
    { url: '/market', name: 'Market' },
    { url: '/artist', name: 'STO.RWA' },
    { url: '/news', name: 'News' },
    { url: '/exhibition', name: 'Community' },
    { external: true, url: 'https://connector.eagle3dstreaming.com/v5/UNILAPSE/Unilapse/default?appVersion=1', name: 'VR' },
    { external: true, url: '', name: 'Launch App' },
  ];

  const handleLaunchAppClick = () => {
    // Update the state to show the popup
    setShowLaunchAppPopup(true);
  };

  const closeLaunchAppPopup = () => {
    setShowLaunchAppPopup(false);
  };

  const isShowBanner = location.pathname.includes('exhibition') || location.pathname.includes('user-board');

  useEffect(() => {
    if (isShowBanner) {
      handleShowBanner(true);
    } else {
      handleShowBanner(false);
    }
  }, [location.pathname]);

  Nav.closeMobileNav = () => {
    setIsClicked(false);
  };

  const handleShowBanner = _showBanner => {
    if (_showBanner !== showBanner) {
      setShowBanner(_showBanner);
    }
  };

  const handleMobileMenu = () => {
    setIsClicked(!isClicked);
  };

  return (
    <div className="col relative">
      {showBanner && (
        <div
          className="nav-banner centered white poppins font-40"
          style={{
            backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0.25)), url(${global_url_top_ad})`,
            backgroundPosition: 'center',
            backgroundSize: 'cover',
          }}
        />
      )}
      <header className="nav-wrapper">
        <div className="nav max-width header-zindex">
          <div className="nav-inside row align-center justify-between">
            {/* <Logo onClick={() => navigate('/')} width={46} className="link" /> */}
            <img src={newLogo} alt="new_logo" onClick={() => navigate('/')} height={46} className="link" />
            <div className="row align-center justify-center">
              <div className="menu-list">
                {PC_NAV_PAGES.map(page => (
                  <li className="menu-item inline-block" key={page.url + '_pc'}>
                    {page.external ? (
                      page.name === 'Launch App' ? (
                        // For "Launch App", show the popup
                        <span
                          onClick={handleLaunchAppClick}
                          className="name poppins black font-14 font-weight-600 primary-hover link padding-col-4 padding-row-8 border-radius-10 background-black"
                          style={{ backgroundColor: 'black', color: 'white' }}
                        >
                          {page.name}
                        </span>
                      ) : (
                        // For other pages, open in a new tab
                        <a
                          href={page.url}
                          target="_blank"
                          rel="noreferrer noopener"
                          className="name poppins black font-18 font-weight-600 primary-hover link"
                        >
                          {page.name}
                        </a>
                      )
                    ) : (
                      // For other pages, navigate within the app
                      <span
                        onClick={() => navigate(page.url)}
                        className="name poppins font-18 font-weight-600 black primary-hover link"
                      >
                        {page.name}
                      </span>
                    )}
                  </li>
                ))}
              </div>
              <Suspense fallback={null}>
                <SearchNav />
                <UserStatus />
              </Suspense>
              <button className="hamburger link" onClick={handleMobileMenu}>
                <Hambuger />
              </button>
            </div>
          </div>
        </div>
      </header>
      <MobileNav isClicked={isClicked} handleMobileMenu={handleMobileMenu} externalGallery={externalGallery} />
      {showLaunchAppPopup && (
        <div className="popup">
          <div className="overlap-wrapper">
            <div className="overlap">
              <div className="overlap-group">
                <img
                  className="group"
                  alt="Group"
                  src={group14}
                />
                <div className="overlap-group-wrapper">
                  <div className="div">
                    <div className="overlap-group-2">
                      <div className="ellipse" />
                      <div className="ellipse-2" />
                      <div className="ellipse-3" />
                      <div className="ellipse-4" />
                      <div className="ellipse-5" />
                      <div className="ellipse-6" />
                    </div>
                    <div className="ellipse-7" />
                  </div>
                </div>
                <img
                  className="img"
                  alt="Group"
                  src={group16}
                />
                <div className="enter-universe">ENTER UNIVERSE</div>
                <div className="div-wrapper">
                  <div className="overlap-2">
                    <div className="ellipse-8" />
                    <div className="ellipse-9" />
                  </div>
                </div>
                <div className="group-2">
                  <div className="ellipse-10" />
                  <div className="ellipse-11" />
                  <div className="ellipse-12" />
                  <div className="ellipse-13" />
                  <div className="ellipse-14" />
                  <div className="ellipse-15" />
                </div>
                <img
                  className="ellipse-16"
                  alt="Ellipse"
                  src={ellipse14}
                />
                <div className="x-button" onClick={closeLaunchAppPopup}>
                  <div className="group-4">
                    <div className="overlap-group-3">
                      <div className="rectangle" />
                      <div className="rectangle-2" />
                    </div>
                  </div>
                </div>
              </div>
              <div className='staking'>
                <div className="group-5">
                  <div className="NFT-staking-wrapper">
                    <a className='NFT-staking' href="https://nft-staking.unilapse.app" target="_blank" rel="noreferrer noopener">
                      NFT STAKING
                    </a>
                  </div>
                </div>
                <div className="group-3">
                  <div className="token-staking-wrapper">
                    <a className='token-staking' href="https://staking.unilapse.app" target="_blank" rel="noreferrer noopener">
                      TOKEN STAKING
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Nav;

export const closeMobileNav = () => {
  Nav.closeMobileNav();
};
